module.exports = __webpack_public_path__ + "img/bg04.6ba4304a.png";